import artifact from '$houdini/artifacts/UpdateInventoryType'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateInventoryTypeStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
